import React, { useEffect } from 'react';
import { PeekBox, PeekButton } from '@piiqtechnologies/ui-components';
import { Eye } from '@piiqtechnologies/svg-icons';
import { usePannellumViewer } from '../../../components/pannellum-viewer/PannellumProvider.js';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../../../utils/ErrorProvider.js';
import { useLoader } from '../../../../utils/LoaderProvider.js';
import '../../../../utils/RefetchProvider.js';
import '../../../../utils/NotificationProvider.js';
import 'tslib';
import '../../../../utils/ContactProvider.js';
import '../../../../utils/PolicyProvider.js';
import '../../../../utils/AnalyticsProvider.js';
import '@analytics/storage-utils';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import '../../../../types/Space.js';
import '../../../../types/Tour.js';
import '../../../../utils/analyticsPlugin.js';
import '../../../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../../../utils/cookieUtils.js';
import '../../../../utils/termsConditionsAgreementsUtils.js';
import '../../../../services/base/baseDiscoverService.js';
import '../../../../services/base/baseV3Service.js';
import '../../../../services/base/baseInsightsService.js';
import '../../../../services/sgtService.js';
import '../../../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../../../services/base/internalApiBaseService.js';
import '../../../../services/base/casaBaseService.js';
import '../../../../services/scanRequestsService.js';
import '../../../../services/db/insightsReportsDB.js';
import '../../../../services/aiDiscoverability.js';
import 'dot-object';
import '../../../../apis/analytics/useDownloadAnalyticsReports.js';
import { useUpdateSpaceNode } from '../../../../apis/space/useUpdateSpaceNode.js';
import '../../../../apis/upload/useSignedURL.js';
import { getNodeById } from '../../../components/pannellum-viewer/pannellumUtils.js';

const StartWithViewCtrl = () => {
    const { getConfig, getYaw, details, setViewerContext } = usePannellumViewer();
    const [updateSpaceNode, updatedSpace, updateSpaceNodeInProgress, updateSpaceNodeError] = useUpdateSpaceNode();
    const { nodeId } = getConfig();
    const node = getNodeById(details.nodes, nodeId);
    const { setError } = useError();
    const { setLoader } = useLoader();
    const updateStartWithView = () => {
        updateSpaceNode({
            spaceId: details._id,
            node: {
                rotation: Object.assign(Object.assign({}, node.rotation), { yaw: getYaw() }),
            },
            nodeId,
        });
    };
    useEffect(() => {
        if (updatedSpace) {
            setViewerContext({ details: updatedSpace });
        }
    }, [updatedSpace]);
    useEffect(() => {
        if (updateSpaceNodeError) {
            setError(updateSpaceNodeError === null || updateSpaceNodeError === void 0 ? void 0 : updateSpaceNodeError.message);
        }
    }, [updateSpaceNodeError]);
    useEffect(() => {
        setLoader(updateSpaceNodeInProgress, "updateSpaceNodeInProgress");
        return () => setLoader(false, "updateSpaceNodeInProgress");
    }, [updateSpaceNodeInProgress]);
    return (React.createElement(PeekBox, null,
        React.createElement(PeekButton, { onClick: updateStartWithView, "aria-label": "Start With This View", variant: "outlined", color: "secondary", startIcon: React.createElement(Eye, null), sx: {
                lineBreak: "auto",
                height: "auto",
                minHeight: 28,
            } }, "Start With This View")));
};

export { StartWithViewCtrl, StartWithViewCtrl as default };
